<div [formGroup]="form" fxLayout="column" fxLayoutGap="10px">
	<mat-form-field>
		<input
			[textMask]="phoneMask"
			autocomplete="off"
			matInput
			placeholder="Phone Number"
			[formControl]="phoneNumberInput"
			required
		/>
		<mat-error *ngIf="phoneNumberInput.hasError('required')"
			>Required</mat-error
		>
		<mat-error *ngIf="phoneNumberInput.hasError('badPhoneNumber')"
			>Invalid phone number format</mat-error
		>
	</mat-form-field>
	<mat-form-field>
		<input
			autocomplete="off"
			matInput
			placeholder="Description"
			formControlName="description"
		/>
	</mat-form-field>
	<mat-checkbox formControlName="isPrimary" fxFlex="100%">
		Is Primary Phone Number
	</mat-checkbox>
</div>
